/// <amd-module name="Feed/Legacy/Helpers/DependencyHelper" />
import { findIndex } from "OfficeFabric/Utilities";

import { IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";

import { DataProviderConstants, FeedServiceInstanceId } from "Feed/Common/Constants/Constants";
import { PackageDependency } from "Feed/Common/Contracts/Feed";
import { PackageDependencyDetails } from "Feed/Common/Contracts/Feed.Internal";
import { IDependency, IDependencyGroup } from "Feed/Common/Types/IDependency";
import * as Url_Helper from "Feed/Legacy/Helpers/UrlHelper";

export class DependencyHelper {
    public static async getDependenciesForPackageVersionAsync(
        pageContext: IVssPageContext,
        projectName: string,
        feedId: string,
        packageId: string,
        packageVersionId: string,
        protocolType: string
    ): Promise<PackageDependencyDetails[]> {
        const contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
        const properties = {
            projectName,
            feedId,
            packageId,
            packageVersionId,
            protocolType
        };

        try {
            const dependencyDetails = await contributionService.getDataAsync<PackageDependencyDetails[]>(
                DataProviderConstants.FeedPackageDependenciesDataProvider,
                properties,
                true /* ignoreCache */,
                FeedServiceInstanceId
            );
            return dependencyDetails;
        } catch (error) {
            // On error resolving data provider, return null for package dep details
            return null;
        }
    }

    public static groupDependencyDetails(
        pageContext: IVssPageContext,
        dependencies: PackageDependencyDetails[],
        feedName: string,
        protocolType: string
    ): IDependencyGroup[] {
        const dependencyGroups: IDependencyGroup[] = [];

        if (dependencies) {
            for (const dependency of dependencies) {
                const index = findIndex(dependencyGroups, (group: IDependencyGroup) => {
                    return group.group === dependency.group;
                });

                if (index > -1) {
                    dependencyGroups[index].dependencies.push(<IDependency>{
                        name: dependency.packageName,
                        versionRange: dependency.versionRange,
                        link: Url_Helper.getPackageDependencyUrl(
                            pageContext,
                            feedName,
                            dependency.packageName,
                            protocolType
                        ),
                        packageId: dependency.packageId,
                        packageVersionId: dependency.packageVersionId,
                        normalizedPackageName: dependency.normalizedPackageName,
                        protocolType
                    });
                } else {
                    dependencyGroups.push(<IDependencyGroup>{
                        dependencies: [
                            {
                                name: dependency.packageName,
                                versionRange: dependency.versionRange,
                                link: Url_Helper.getPackageDependencyUrl(
                                    pageContext,
                                    feedName,
                                    dependency.packageName,
                                    protocolType
                                ),
                                packageId: dependency.packageId,
                                packageVersionId: dependency.packageVersionId,
                                normalizedPackageName: dependency.normalizedPackageName,
                                protocolType
                            }
                        ],
                        group: dependency.group
                    });
                }
            }
        }

        return dependencyGroups;
    }

    public static groupDependencies(dependencies: PackageDependency[]): IDependencyGroup[] {
        const dependencyGroups: IDependencyGroup[] = [];

        if (dependencies) {
            for (const dependency of dependencies) {
                const index = findIndex(dependencyGroups, (group: IDependencyGroup) => {
                    return group.group === dependency.group;
                });

                if (index > -1) {
                    dependencyGroups[index].dependencies.push(<IDependency>{
                        name: dependency.packageName,
                        versionRange: dependency.versionRange
                    });
                } else {
                    dependencyGroups.push(<IDependencyGroup>{
                        dependencies: [
                            {
                                name: dependency.packageName,
                                versionRange: dependency.versionRange
                            }
                        ],
                        group: dependency.group
                    });
                }
            }
        }

        return dependencyGroups;
    }
}
